import React, { Component } from 'react';
import Favicon              from 'react-favicon';

class AppFavIcon extends Component
{
    render = () =>
    {
        if (null !== this.props.logo)
        {
            return (<Favicon url={ [this.props.logo] }/>);
        }

        return null;
    }
}

export default AppFavIcon;


// WEBPACK FOOTER //
// ./src/components/App/AppFavIcon.js